import { missionStatuses, participantStatuses } from '../../../../backend/extraTypes';
import { z } from 'zod';
import { shiftSchema } from '../entities/shiftTypes';
export const shiftRowSchema = z.object({
    id: z.string().uuid(),
    created: z.number(),
    createdBy: z.string().uuid(),
    updated: z.number(),
    updatedBy: z.string().uuid(),
    parentId: z.string().uuid().optional(),
    columns: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
    data: shiftSchema,
});
const shiftMissionDetailsSchema = z.object({
    missionTypeId: z.string().uuid(),
    missionName: z.string(),
    missionStatus: z.enum(missionStatuses),
    missionOrganizationSharing: z.string().uuid().array(),
});
const shiftAnalyticsSchema = z.object({
    analytics: z.object({
        totalPendingParticipants: z.number(),
        totalApprovedParticipants: z.number(),
        totalPendingHours: z.number(),
        totalApprovedHours: z.number(),
    }),
});
const shiftUserParticipationSchema = z.object({
    userParticipations: z
        .object({
        positionId: z.string().uuid(),
        positionName: z.string(),
        status: z.enum(participantStatuses),
    })
        .array(),
});
const shiftPermissionsSchema = z.object({
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
});
export const shiftWithMissionSchema = shiftRowSchema.merge(shiftMissionDetailsSchema);
export const shiftWithUserParticipationSchema = shiftRowSchema.merge(shiftUserParticipationSchema);
export const shiftWithMissionAndUserParticipationSchema = shiftRowSchema
    .merge(shiftMissionDetailsSchema)
    .merge(shiftUserParticipationSchema);
export const shiftWithMissionAndAnalyticsAndUserParticipationSchema = shiftRowSchema
    .merge(shiftMissionDetailsSchema)
    .merge(shiftAnalyticsSchema)
    .merge(shiftUserParticipationSchema);
export const shiftWithAnalyticsSchema = shiftRowSchema.merge(shiftAnalyticsSchema);
export const shiftWithAnalyticsAndPermissionsSchema = shiftRowSchema.merge(shiftAnalyticsSchema).merge(shiftPermissionsSchema);
export const shiftWithAnalyticsAndMissionSchema = shiftRowSchema.merge(shiftMissionDetailsSchema).merge(shiftAnalyticsSchema);
export const shiftWithAnalyticsAndMissionAndPermissionsSchema = shiftRowSchema
    .merge(shiftMissionDetailsSchema)
    .merge(shiftAnalyticsSchema)
    .merge(shiftPermissionsSchema);
